<template>
  <v-layout row wrap>
    <v-flex xs12 sm5 md4 lg3>
      <v-card flat class="v2-card">
        <v-card-title>Pay dates</v-card-title>
        <v-progress-linear :indeterminate="processBarPayDates" height="3" class="my-0"></v-progress-linear>
        <div class="v2-scroll" @scroll="onPayDatesScroll">
          <v-list two-line class="pa-0">
            <template v-for="(item, i) in payout_pay_paydates.data">
              <v-divider v-if="i" :key="'d' + i"></v-divider>
              <v-list-tile :key="i" :class="{ 'v2-active-tile': item.pay_date == selectedPayDate }" @click="select(item)">
                <v-list-tile-content>
                  <v-list-tile-title><span class="v2-muted">Net pay:</span> <span class="font-weight-bold success--text">{{ item.sum_net_pay | currency }}</span></v-list-tile-title>
                  <v-list-tile-sub-title>{{ item.pay_date }} · Gross {{ item.sum_gross_amt | currency }} · Fee {{ item.sum_mgt_fee | currency }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action class="v2-tile-actions">
                  <v-tooltip v-if="item.note" left>
                    <v-icon slot="activator" small class="v2-muted">info</v-icon>
                    <span>{{ item.note }}</span>
                  </v-tooltip>
                  <v-btn icon small class="ma-0" @click.stop="exportPayoutSheet(item)"><v-icon small>file_download</v-icon></v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list>
        </div>
      </v-card>
    </v-flex>

    <v-flex sm7 md8 lg9 class="hidden-xs-only">
      <v-card flat class="v2-card">
        <v-card-title>Payouts<span v-if="selectedPayDate" class="v2-muted ml-2 body-1">{{ selectedPayDate }}</span></v-card-title>
        <v-progress-linear :indeterminate="processBar || loadingSpin" height="3" class="my-0"></v-progress-linear>
        <div class="v2-scroll v2-table-scroll" @scroll="onTableScroll">
          <v-data-table :headers="headers" :items="payout_wrt_paydates" hide-actions>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.contract_MID }}</td>
              <td>{{ props.item.syndication_company_name }}</td>
              <td>{{ props.item.total_gross_amount | currency }}</td>
              <td>{{ props.item.total_mgt_fee | currency }}</td>
              <td class="font-weight-bold">{{ props.item.total_net_pay | currency }}</td>
              <td>{{ props.item.numbers_of_transactions }}</td>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-flex>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="secondary">
          <v-btn icon dark @click="dialog = false"><v-icon>close</v-icon></v-btn>
          <v-toolbar-title>Payouts ({{ selectedPayDate }})</v-toolbar-title>
        </v-toolbar>
        <v-progress-linear :indeterminate="processBar || loadingSpin" height="3" class="my-0"></v-progress-linear>
        <div class="v2-scroll v2-table-scroll" @scroll="onTableScroll">
          <v-data-table :headers="headers" :items="payout_wrt_paydates" hide-actions>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.contract_MID }}</td>
              <td>{{ props.item.syndication_company_name }}</td>
              <td>{{ props.item.total_gross_amount | currency }}</td>
              <td>{{ props.item.total_mgt_fee | currency }}</td>
              <td class="font-weight-bold">{{ props.item.total_net_pay | currency }}</td>
              <td>{{ props.item.numbers_of_transactions }}</td>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import payouts from '../../mixins/payouts'

export default {
  mixins: [payouts],
  data: () => ({
    dialog: false,
    headers: [
      { text: 'MID', sortable: false },
      { text: 'Company Name', sortable: false },
      { text: 'Gross Amount', sortable: false },
      { text: 'Mgt Fee', sortable: false },
      { text: 'Net Pay', sortable: false },
      { text: 'No. of Transactions', sortable: false },
    ],
  }),
  methods: {
    select(item) {
      this.getPayoutsWRTPayDates(item)
      if (this.$vuetify.breakpoint.xsOnly) this.dialog = true
    },
  },
}
</script>

<style scoped>
.v2-scroll { max-height: 65vh; overflow-y: auto; }
.v2-tile-actions { flex-direction: row; align-items: center; }
</style>
